import { combineReducers } from 'redux';
import formFields from './formFields';
import product from './product';
import steps from './steps';
import users from './users';
import modules from './modules';
import extras from './extras';
import settings from './settings';

const wizard = combineReducers({
    steps,
    product,
    formFields,
    users,
    modules,
    extras,
    settings,
});

export default wizard;